import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";

const AdditionalNetworkServicesOverview = ({ data }) => {
  const {
    cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin,
    cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin,
    cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other,
    cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other,
  } = data["2_5"];

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <ReviewSummarySectionHeading
            title="Additional Network Services (TTAC, CTP)"
          />
        </div>
        <ReviewAttribute
          label="Would you like to enable Tap To Add Card service on your BIN?"
          value={
            cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin?.length
              ? cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin === "other"
                ? `Other (${toTitleCase(cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin_other)})`
                : toTitleCase(cn_aditional_network_services_would_you_like_to_enable_tap_to_card_on_your_bin)
              : "-"
          }
        />
        <ReviewAttribute
          label="Would you like to enable Click to Pay service on your BIN?"
          value={
            cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin?.length
              ? cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin === "other"
                ? `Other (${toTitleCase(cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin_other)})`
                : toTitleCase(cn_aditional_network_services_would_you_like_to_enable_click_to_pay_service_on_your_bin)
              : "-"
          }
        />
      </div>
      <div className="mt-16"></div>
    </div>
  );
};
export default AdditionalNetworkServicesOverview;
